var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.275 9.05a5.688 5.688 0 1 0-1.222 1.224h-.001c.026.035.054.068.086.1l3.369 3.37a.875.875 0 0 0 1.238-1.238l-3.37-3.369a.883.883 0 0 0-.1-.088v.001Zm.226-3.364a4.813 4.813 0 1 1-9.625 0 4.813 4.813 0 0 1 9.625 0Z",
    fill: "#09205D"
  })));
};

export default SvgSearch;